var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.59.59A2.006,2.006,0,0,0,7.17,0H2A2,2,0,0,0,.01,2L0,14a2.006,2.006,0,0,0,2,2H18a2.006,2.006,0,0,0,2-2V4a2.006,2.006,0,0,0-2-2H10Z",
    fill: "#e0001b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderRed);
export default __webpack_public_path__ + "static/media/folder-red.02fe405b58ae892398cefd44e951e5b5.svg";
export { ForwardRef as ReactComponent };